
export const DZG_API_HOST = "deezer-graph-api-dwvn65bkbq-ew.a.run.app"; // "localhost";
export const DZG_API_PORT = NaN; // 8502;
export const DZG_API_BASE_URL = (isNaN(DZG_API_PORT)) ? `https://${DZG_API_HOST}` : `http://${DZG_API_HOST}:${DZG_API_PORT}`;
export const VERSION = '1.0';
export const SESSION_ID_KEY = "session_id";